import * as React from 'react';

import { cn } from './utils';

export type VideoPlayerProps = Omit<
  React.VideoHTMLAttributes<HTMLVideoElement>,
  'controlsList' | 'playsInline' | 'disablePictureInPicture'
> & {
  /**
   * If true, attempts to prevent fullscreen / remote playback UI.
   * Note: browser support varies; this is best-effort.
   */
  disableFullscreen?: boolean;
};

export const VideoPlayer = React.forwardRef<HTMLVideoElement, VideoPlayerProps>(
  ({ className, disableFullscreen = true, ...props }, ref) => {
    return (
      <video
        ref={ref}
        className={cn(className)}
        playsInline
        disablePictureInPicture={disableFullscreen}
        controlsList={disableFullscreen ? 'nofullscreen noremoteplayback nodownload' : undefined}
        {...props}
      />
    );
  }
);
VideoPlayer.displayName = 'VideoPlayer';

